import Reveal from "@/components/base/Reveal";
import { Link } from "react-router-dom";

export default function CriaSiteHero() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 text-background-50">
      <div className="absolute inset-0 nx-grid opacity-30"></div>
      <div className="nx-glow absolute -top-40 right-0 h-[460px] w-[460px] animate-pulseGlow"></div>
      <div className="nx-glow absolute bottom-0 -left-40 h-[360px] w-[360px] animate-pulseGlow"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pt-28 pb-16 md:px-8 md:pt-36 md:pb-24">
        <Reveal>
          <nav
            aria-label="Trilha de navegação"
            className="flex flex-wrap items-center gap-2 text-xs text-background-400"
          >
            <Link to="/" className="transition-colors hover:text-background-50">
              Início
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span className="text-background-200">Criação de Sites</span>
          </nav>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
          <div>
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-300">
                <i className="ri-eye-line" aria-hidden="true"></i>
                Criação de Sites Profissionais
              </span>
            </Reveal>

            <Reveal delay={80}>
              <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-[3.1rem]">
                Seu novo site começa com uma prévia.
              </h1>
            </Reveal>

            <Reveal delay={140}>
              <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
                Criamos uma prévia visual do seu site para sua empresa conhecer a proposta antes de
                contratar. Design moderno, rápido, responsivo e pensado para transformar visitantes em
                clientes.
              </p>
            </Reveal>

            <Reveal delay={200}>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
                <a
                  href="#previa"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-image-add-line text-lg" aria-hidden="true"></i>
                  Quero minha prévia gratuita
                </a>
                <a
                  href="#como-funciona"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                >
                  <i className="ri-play-circle-line text-lg" aria-hidden="true"></i>
                  Ver como funciona
                </a>
              </div>
            </Reveal>

            <Reveal delay={240}>
              <ul className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-300">
                {["Sem compromisso", "Design personalizado", "Prévia inicial sem custo"].map((item) => (
                  <li key={item} className="inline-flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-secondary-400" aria-hidden="true"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <Reveal delay={180}>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-background-50/10 bg-background-50/5 p-2">
                <div className="h-[260px] w-full overflow-hidden rounded-xl md:h-[360px]">
                  <img
                    src="https://storage.helloreaddy.io/project_files/9d609ae5-b03e-4dcf-a75d-08eaee046d5d/dacb00d5-ab92-4f35-9126-c7ec81918a78_compressed_CRIAR-SITE.webp"
                    alt="Prévia de site profissional exibida em notebook e celular pela NXHOST"
                    title="Criação de sites profissionais NXHOST — prévia do seu site"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="absolute -bottom-4 left-4 right-4 rounded-xl border border-background-50/10 bg-foreground-900/90 p-4 backdrop-blur-sm sm:left-6 sm:right-auto sm:w-64">
                <div className="flex items-center justify-between">
                  <span className="text-[11px] uppercase tracking-wide text-background-400">
                    Sua prévia
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-secondary-400">
                    <span className="h-2 w-2 rounded-full bg-secondary-400"></span>
                    Sem custo
                  </span>
                </div>
                <p className="mt-2 font-heading text-sm font-semibold text-background-50">
                  Veja como sua empresa pode ficar antes de contratar
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}